import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../common/Button';
import { FaUserSecret } from 'react-icons/fa';

export const AnonymousLoginButton = ({ className = '' }) => {
    const { signInAnonymously } = useAuth();
    const navigate = useNavigate();

    const handleAnonymousLogin = async () => {
        try {
            await signInAnonymously();
            navigate('/dashboard');
        } catch (error) {
            console.error('Anonymous login failed:', error);
        }
    };

    return (
        <Button
            type="button"
            variant="secondary"
            onClick={handleAnonymousLogin}
            className={`flex items-center justify-center gap-2 ${className}`}
            aria-label="Continue as guest"
        >
            <FaUserSecret className="h-5 w-5" />
            Continue as Guest
        </Button>
    );
}; 